import { configureStore } from "@reduxjs/toolkit";
import { loadState, saveState } from "./localStorage";
import counterReducer from "../features/counter/counterSlice";
import itineraryDaysReducer from "../features/itineraryDays/itineraryDaysSlice";
import buildMyHolidayReducer from "../features/buildMyHoliday/buildMyHolidaySlice";
import createYourHolidayReducer from "../features/createYourHoliday/createYourHolidaySlice";
import suitcaseReducer from "../features/suitcase/suitcaseSlice";
import holidaysDashboardReducer from "../features/holidays-dashboard/holidays-dashboard-slice";
import focusItineraryReducer from "../features/focusitinerary/focusItinerarySlices";
import registerReducer from "../features/register/registerSlice";
import travelAgentCompaniesReducer from "../features/travelAgentCompanies/travelAgentCompaniesSlice";
import errorMessageReducer from "../features/errorMessage/errorMessageSlice";
import loaderReducer from "../features/loader/loaderSlice";
import campaignReducer from "../features/campaign/campaignSlice";
import itineraryPortsReducer from "../features/itineraryPorts/itineraryPortsSlice";
import itineraryRegionsReducer from "../features/itineraryRegions/itineraryRegionsSlice";
import customerHolidayItinerariesReducer from "../features/customerHolidayItineraries/customerHolidayItinerariesSlice";
import customerHolidayLinksReducer from "../features/customerHolidayLinks/customerHolidayLinksSlice";
import focusHolidaysReducer from "../features/focusHolidays/focusHolidaysSlice";
import itineraryDetailsPublicReducer from "../features/itineraryDays/itineraryDetailsPublic";
import cmsAnalyticsData from "../features/analytics/analyticsSlice";
import detailsConfirmationReducer from "../features/detailsConfirmation/detailsConfirmationSlice";
import countrySelectorReducer from "../features/countrySelector/countrySelectorSlice";
import proposalInfoReducer from "../features/proposalInfo/proposalInfoSlice";
import likedCruisesReducer from "../features/likedCruises/likedCruisesSlice";
import royalBridgeReducer from "../features/royalBridge/royalBridgeSlice";
import commercialPerformanceReducer from "../features/royalBridge/commercialPerformanceSlice";
import royalMomentumReducer from "../features/royalMomentum/royalMomentumSlice";
import royalMomentumContentManagementReducer from "../features/royalMomentum/royalMomentumContentManagementSlice";
import meetingHubReducer from "../features/meetingHub/meetingHubSlice";
import { royalBridgeAgentEngagementApi } from "../features/royalBridge/royalBridgeAgentEngagementApi";
import { royalMomentumAgentEngagementApi } from "../features/royalMomentum/royalMomentumAgentEngagementApi";
import { royalMomentumPlansAndTargetsApi } from "../features/royalMomentum/royalMomentumPlansAndTargetsApi";
import { royalBridgePlansAndTargetsApi } from "../features/royalBridge/royalBridgePlansAndTargetsApi";
import { royalMomentumProfileApi } from "../features/royalMomentum/royalMomentumProfileApi";
import { royalMomentumBrandsApi } from "../features/royalMomentum/royalMomentumBrandsApi";
import { royalMomentumCommercialPerformanceApi } from "../features/royalMomentum/royalMomentumCommercialPerformanceApi";
import { royalMomentumMeetingsApi } from "../features/royalMomentum/royalMomentumMeetingsApi";
import { royalMomentumGrowthPrioritiesApi } from "../features/royalMomentum/royalMomentumGrowthPrioritiesApi";
import { royalMomentumTasksAndFollowupsApi } from "../features/royalMomentum/royalMomentumTasksAndFollowupsApi";

const preloadedState = loadState();
import { royalMomentumContactsApi } from "../features/royalMomentum/royalMomentumContactsApi";
import { royalMomentumQuickCallApi } from "../features/royalMomentum/royalMomentumQuickCallApi";
import { royalMomentumStoreVisitsApi } from "../features/royalMomentum/royalMomentumStoreVisitsApi";
import { royalMomentumKamVisitsApi } from "../features/royalMomentum/royalMomentumKamVisitsApi";
import { royalMomentumNotificationsApi } from "../features/royalMomentum/royalMomentumNotificationsApi";

export const store = configureStore({
    preloadedState,
    reducer: {
        counter: counterReducer,
        itineraryDays: itineraryDaysReducer,
        buildMyHoliday: buildMyHolidayReducer,
        createYourHoliday: createYourHolidayReducer,
        suitcase: suitcaseReducer,
        holidaysDashboard: holidaysDashboardReducer,
        focusItinerary: focusItineraryReducer,
        register: registerReducer,
        travelAgentCompanies: travelAgentCompaniesReducer,
        errorMessage: errorMessageReducer,
        loader: loaderReducer,
        campaign: campaignReducer,
        itineraryPorts: itineraryPortsReducer,
        itineraryRegions: itineraryRegionsReducer,
        customerHolidayItineraries: customerHolidayItinerariesReducer,
        customerHolidayLinks: customerHolidayLinksReducer,
        focusHolidays: focusHolidaysReducer,
        publicItineraryDetails: itineraryDetailsPublicReducer,
        analyticsData: cmsAnalyticsData,
        detailsConfirmation: detailsConfirmationReducer,
        countrySelector: countrySelectorReducer,
        proposalInfo: proposalInfoReducer,
        likedCruises: likedCruisesReducer,
        royalBridge: royalBridgeReducer,
        commercialPerformance: commercialPerformanceReducer,
        royalMomentum: royalMomentumReducer,
        royalMomentumContentManagement: royalMomentumContentManagementReducer,
        meetingHub: meetingHubReducer,
        [royalBridgeAgentEngagementApi.reducerPath]: royalBridgeAgentEngagementApi.reducer,
        [royalMomentumAgentEngagementApi.reducerPath]: royalMomentumAgentEngagementApi.reducer,
        [royalMomentumPlansAndTargetsApi.reducerPath]: royalMomentumPlansAndTargetsApi.reducer,
        [royalBridgePlansAndTargetsApi.reducerPath]: royalBridgePlansAndTargetsApi.reducer,
        [royalMomentumProfileApi.reducerPath]: royalMomentumProfileApi.reducer,
        [royalMomentumBrandsApi.reducerPath]: royalMomentumBrandsApi.reducer,
        [royalMomentumCommercialPerformanceApi.reducerPath]: royalMomentumCommercialPerformanceApi.reducer,
        [royalMomentumMeetingsApi.reducerPath]: royalMomentumMeetingsApi.reducer,
        [royalMomentumGrowthPrioritiesApi.reducerPath]: royalMomentumGrowthPrioritiesApi.reducer,
        [royalMomentumTasksAndFollowupsApi.reducerPath]: royalMomentumTasksAndFollowupsApi.reducer,
        [royalMomentumContactsApi.reducerPath]: royalMomentumContactsApi.reducer,
        [royalMomentumQuickCallApi.reducerPath]: royalMomentumQuickCallApi.reducer,
        [royalMomentumStoreVisitsApi.reducerPath]: royalMomentumStoreVisitsApi.reducer,
        [royalMomentumKamVisitsApi.reducerPath]: royalMomentumKamVisitsApi.reducer,
        [royalMomentumNotificationsApi.reducerPath]: royalMomentumNotificationsApi.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(
            royalBridgeAgentEngagementApi.middleware,
            royalMomentumAgentEngagementApi.middleware,
            royalMomentumPlansAndTargetsApi.middleware,
            royalBridgePlansAndTargetsApi.middleware,
            royalMomentumProfileApi.middleware,
            royalMomentumBrandsApi.middleware,
            royalMomentumCommercialPerformanceApi.middleware,
            royalMomentumContactsApi.middleware,
            royalMomentumMeetingsApi.middleware,
            royalMomentumGrowthPrioritiesApi.middleware,
            royalMomentumTasksAndFollowupsApi.middleware,
            royalMomentumQuickCallApi.middleware,
            royalMomentumStoreVisitsApi.middleware,
            royalMomentumKamVisitsApi.middleware,
            royalMomentumNotificationsApi.middleware
        ),
});

let lastSaveTime = 0;
let pendingTimeout;
store.subscribe(() => {
    const now = Date.now();
    if (now - lastSaveTime >= 1000) {
        lastSaveTime = now;
        saveState(store.getState());
    } else if (!pendingTimeout) {
        pendingTimeout = setTimeout(() => {
            lastSaveTime = Date.now();
            pendingTimeout = null;
            saveState(store.getState());
        }, 1000 - (now - lastSaveTime));
    }
});
